import {Button, Col, Input, Row, Space, Typography, Radio, Form} from "antd";
import React, {useEffect, useState} from "react";
import Icons from "assets/icons";
import {DataInputField, InputFields} from "components/common";
import "./PupilExpand.scss";
import Icon from "@ant-design/icons";
import {FieldsPulpil1, FieldsPulpil2} from "./PupilExpand.config";
import {useAppSelector} from "redux/hooks";

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
};

const PupilExpand: React.FC<Props> = ({isOpen, setIsOpen, index}) => {
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );
  const ref = useAppSelector(state => state.examination.ref);
  const defaultValues = {
    "Hình dạng": null,
    "Kích cỡ đồng tử": null,
    "Phản xạ ánh sáng trực tiếp": "Bình thường",
    "Phản xạ ánh sáng đồng thuận": "Bình thường",
    "Ghi chú": null,
  };
  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (ref) {
        ref.setFieldValue(
          [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "PUPIL"],
          defaultValues
        );
      }
    }
    if (ref) {
      ref.setFieldValue(
        [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "PUPIL", "show"],
        isOpen
      );
    }
  }, [isOpen, ref]);
  useEffect(() => {
    if (objectChanDoan && ref) {
      const show = ref.getFieldValue([
        `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
        "PUPIL",
        "show",
      ]);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
    }
  }, [objectChanDoan, ref]);
  return (
    <Space
      direction="vertical"
      className="space-common space-pupil"
      size={"middle"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub rev={0} /> : <Icons.add rev={0} />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">ĐỒNG TỬ</Typography>
      </Row>

      {isOpen ? (
        <div>
          <Row gutter={[16, 16]}>
            <InputFields data={index === 0 ? FieldsPulpil1 : FieldsPulpil2} />
          </Row>
        </div>
      ) : null}
    </Space>
  );
};

export default PupilExpand;
